import * as React from "react";
const SvgFiRrMeterBolt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-meter-bolt_svg__a)">
      <path
        fill="#062147"
        d="M16.932 21.886a1 1 0 0 1-.568 1.296c-1.39.543-2.858.818-4.364.818-6.617 0-12-5.383-12-12S5.383 0 12 0c4.531 0 8.627 2.508 10.691 6.545a1.001 1.001 0 0 1-1.782.91A9.97 9.97 0 0 0 11.999 2C6.486 2 2 6.486 2 12s4.486 10 10 10a9.9 9.9 0 0 0 3.636-.682 1 1 0 0 1 1.295.567zM5 8v2a1 1 0 1 0 2 0V8a1 1 0 1 0-2 0m4 0v2a1 1 0 1 0 2 0V8a1 1 0 1 0-2 0m4 0v2a1 1 0 1 0 2 0V8a1 1 0 1 0-2 0m10.768 8.684a1.47 1.47 0 0 0-1.249-.686h-4.154l2.51-4.512a1 1 0 1 0-1.748-.972l-2.97 5.342a1.47 1.47 0 0 0 .066 1.441c.272.438.743.701 1.259.701h4.153l-2.509 4.517a.999.999 0 1 0 1.748.97l2.987-5.381c.215-.461.18-.991-.093-1.42"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-meter-bolt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMeterBolt;
